export const discussionProfileStore = {
    state: () => ({
        discussionProfiles: [],
        isShowAddDiscussionProfile: false,
        isShowEditDiscussionProfile: false,
        isShowDiscussionProfileModes: false,
        selectedDiscussionProfile: null
    }),
    mutations: {
        setAvailableDiscussionProfiles(state, discussionProfiles) {
            state.discussionProfiles = Array.isArray(discussionProfiles) ? discussionProfiles : [];
        },
        setIsShowAddDiscussionProfileStatus(state, status) {
            state.isShowAddDiscussionProfile = status;
        },
        setIsShowEditDiscussionProfileStatus(state, status) {
            if (status === false) {
                state.selectedDiscussionProfile = null;
            }
            state.isShowEditDiscussionProfile = status;
        },
        setIsShowDiscussionProfileModesStatus(state, status) {
            if (status === false) {
                state.selectedDiscussionProfile = null;
            }
            state.isShowDiscussionProfileModes = status;
        },
        setSelectedDiscussionProfile(state, discussionProfile) {
            state.selectedDiscussionProfile = discussionProfile;
        }
    }
};
